import { call } from '@advanza/api'
import { countryCodes, countrySettings, validateCifNifNie, validateVat } from '@advanza/func'
import { Col, Row } from '@advanza/grid'
import { InputField } from '@advanza/input'
import { Modal } from '@advanza/modal'
import { Button, Divider, HoverText, LoadingDots, PreIcon } from '@advanza/ui'
import {
    PAYMENT_METHOD_DIRECT_DEBIT,
    PAYMENT_METHOD_MANUAL_TRANSFER,
    SUBSCRIPTION_STATUS_ACTIVE,
    SUBSCRIPTION_STATUS_CANCELLED,
    SUBSCRIPTION_STATUS_UNVERIFIED,
} from '@trustoo/types/entity/paymentInfo'
import { fetchProvider, savePaymentData, VAT_STATE_UNKNOWN, VAT_STATES } from 'actions/providers'
import Label from 'components/ui/Label'
import SafeButton from 'components/ui/SafeButton'
import { useChangeEntity } from 'hooks/entityHooks'
import { useAppDispatch } from 'hooks/hooks'
import { useProvider } from 'hooks/providerHooks'
import React, { useState } from 'react'

const bics = [
    { name: 'ABN Amro - ABNANL2A', value: 'ABNANL2A' },
    { name: 'ABN Amro2 - ABNANL2R', value: 'ABNANL2R' },
    { name: 'Aegon bank - AEGONL2U', value: 'AEGONL2U' },
    { name: 'Argenta Spaarbank - ARSNNL21', value: 'ARSNNL21' },
    { name: 'Allianz Nederland Asset Management - ANAANL21', value: 'ANAANL21' },
    { name: 'Anadolubank - ANDLNL2A', value: 'ANDLNL2A' },
    { name: 'Achmea Bank - ARBNNL22', value: 'ARBNNL22' },
    { name: 'Argenta Spaarbank - ARSNNL21', value: 'ARSNNL21' },
    { name: 'GE Artesia Bank - ARTENL2A', value: 'ARTENL2A' },
    { name: 'ASN BANK - ASNBNL21', value: 'ASNBNL21' },
    { name: 'ASR BANK - ASRBNL2R', value: 'ASRBNL2R' },
    { name: 'Amsterdam Trade Bank - ATBANL2A', value: 'ATBANL2A' },
    { name: 'ING Belgie - BBRUNL2X', value: 'BBRUNL2X' },
    { name: 'Banque Chaabi Du Maroc - BCDMNL22', value: 'BCDMNL22' },
    { name: 'Intesa Sanpaolo - BCITNL2A', value: 'BCITNL2A' },
    { name: 'BinckBank - BICKNL2A', value: 'BICKNL2A' },
    { name: 'Bank of China - BKCHNL2R', value: 'BKCHNL2R' },
    { name: 'Bank Mendes Gans - BKMGNL2A', value: 'BKMGNL2A' },
    { name: 'Bmce Euroservice - BMEUNL21', value: 'BMEUNL21' },
    { name: 'Bank Nederlandse Gemeenten (BNG - BNGHNL2G)', value: 'BNGHNL2G' },
    { name: 'BNP Paribas Fortis - BNPANL2A', value: 'BNPANL2A' },
    { name: 'Bank of America - BOFANLNX', value: 'BOFANLNX' },
    { name: 'Bank of Scotland: , Amsterdam - BOFSNL21002', value: 'BOFSNL21002' },
    { name: 'bunq - BUNQNL2A', value: 'BUNQNL2A' },
    { name: 'C & E Bankiers - CEBUNL2U', value: 'CEBUNL2U' },
    { name: 'Citybank International - CITINL2X', value: 'CITINL2X' },
    { name: 'JPMorgan Chase - CHASNL2X', value: 'CHASNL2X' },
    { name: 'Citco Bank Nederland  - CITCNL2A', value: 'CITCNL2A' },
    { name: 'Commerzbank - COBANL2X', value: 'COBANL2X' },
    { name: 'Deutsche Bank - DEUTNL2N', value: 'DEUTNL2N' },
    { name: 'Demir-Halk Bank  - DHBNNL2R', value: 'DHBNNL2R' },
    { name: 'Delta Lloyd Bank - DLBKNL2A', value: 'DLBKNL2A' },
    { name: 'F. van Lanshot Bankiers - FVLBNL22', value: 'FVLBNL22' },
    { name: 'NIBC Bank - DNIBNL2G', value: 'DNIBNL2G' },
    { name: 'Credit Europe Bank - FBHLNL2A', value: 'FBHLNL2A' },
    { name: 'De Nederlandsche Bank - FLORNL2A', value: 'FLORNL2A' },
    { name: 'Friesland Bank - FRBKNL2L', value: 'FRBKNL2L' },
    { name: 'FGH Bank - FRGHNL21', value: 'FRGHNL21' },
    { name: 'Theodoor Gilissen Bankiers - GILLNL2A', value: 'GILLNL2A' },
    { name: 'Svenska Handelsbanken AB - HANDNL2A', value: 'HANDNL2A' },
    { name: 'Hof Hoorneman Bankiers - HHBANL22', value: 'HHBANL22' },
    { name: 'HSBC BANK - HSBCNL2A', value: 'HSBCNL2A' },
    { name: 'Industrial and Commercial Bank of China - ICBKNL2A', value: 'ICBKNL2A' },
    { name: 'ING bank - INGBNL2A', value: 'INGBNL2A' },
    { name: 'Insinger de Beaufort - INSINL2A', value: 'INSINL2A' },
    { name: 'Yapi Kredi Bank - KABANL2A', value: 'KABANL2A' },
    { name: 'KAS BANK - KASANL2A', value: 'KASANL2A' },
    { name: 'KNAB - KNABNL2H', value: 'KNABNL2H' },
    { name: 'Korea Exchange Bank - KOEXNL2A', value: 'KOEXNL2A' },
    { name: 'KBC Bank - KREDNL2X', value: 'KREDNL2X' },
    { name: 'Lloyds Bank - LOYDNL2A', value: 'LOYDNL2A' },
    { name: 'LeasePlan Corporation - LPLNNL2F', value: 'LPLNNL2F' },
    { name: 'Mizuho Corporate Bank - MHCBNL2A', value: 'MHCBNL2A' },
    { name: 'Nationale-Nederlanden Bank - NNBANL2G', value: 'NNBANL2G' },
    { name: 'Nederlandse Waterschapsbank - NWABNL2G', value: 'NWABNL2G' },
    { name: 'Levob Bank - OVBNNL22', value: 'OVBNNL22' },
    { name: 'Rabobank - RABONL2U', value: 'RABONL2U' },
    { name: 'Royal Bank of Scotland - RBOSNL2A', value: 'RBOSNL2A' },
    { name: 'RegioBank - RBRBNL21', value: 'RBRBNL21' },
    { name: 'SNS Bank - SNSBNL2A', value: 'SNSBNL2A' },
    { name: 'Staalbankiers - STALNL2G', value: 'STALNL2G' },
    { name: 'Triodos Bank - TRIONL2U', value: 'TRIONL2U' },
    { name: 'Garantibank - UGBINL2A', value: 'UGBINL2A' },
    { name: 'Volkswagen Bank - VOWANL21', value: 'VOWANL21' },
    { name: 'ZwitserlevenBank - ZWLBNL21', value: 'ZWLBNL21' },
]

function addValuesFromAutocomplete(changeEntity, autocompleteResult) {
    const components = autocompleteResult.address_components || []
    const addressMap = {
        street_number: { name: 'house_number', key: 'long_name' },
        locality: { name: 'city', key: 'long_name' },
        website: { name: 'city', key: 'long_name' },
        postal_code: { name: 'postal_code', key: 'long_name' },
        route: { name: 'street', key: 'long_name' },
    }
    components.map((component) => {
        const nameAndKey = component.types && addressMap[component.types[0]]
        if (nameAndKey) {
            changeEntity({
                [nameAndKey.name]: component[nameAndKey.key],
            })
        }
    })
    changeEntity({ business_name: autocompleteResult.name })
}

const textValidator = (val) => val && val.length > 0

function getFields(entity, onChangeEntity) {
    return {
        gender: {
            type: 'select',
            className: 'select-min fsize lg',
            options: [
                { value: 1, title: 'Mr' },
                { value: 2, title: 'Mrs' },
            ],
            validator: (val) => val === 1 || val === 2,
        },
        first_name: { type: 'text', placeholder: 'First Name', validator: textValidator },
        last_name: { type: 'text', placeholder: 'Last name', validator: textValidator },
        business_name: {
            type: 'geo',
            placeholder: 'Business name',
            onPlaceChange: (place) => addValuesFromAutocomplete(onChangeEntity, place),
            onChange: null,
            validator: textValidator,
        },
        street: { type: 'text', placeholder: 'Street', validator: textValidator },
        email: {
            type: 'text',
            placeholder: 'email',
            validator: (val) =>
                !val ||
                val.search(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                ) !== -1,
        },
        postal_code: { type: 'text', placeholder: 'Postal code', validator: textValidator },
        city: { type: 'text', placeholder: 'City', validator: textValidator },
        country_code: {
            type: 'select',
            className: 'select-min fsize lg',
            placeholder: 'Country',
            options: countryCodes.map((countryCode) => ({
                value: countryCode,
                title: countryCode,
            })),
        },
        house_number: { type: 'text', placeholder: 'House number', validator: textValidator },
        house_number_add: { type: 'text', placeholder: 'Addition' },
        bank_tnv: {
            type: 'text',
            placeholder: 'bank_tnv',
            validator:
                entity.payment_method === PAYMENT_METHOD_MANUAL_TRANSFER
                    ? () => true
                    : textValidator,
        },
        iban: {
            type: 'text',
            placeholder: 'iban',
            validator:
                entity.payment_method === PAYMENT_METHOD_MANUAL_TRANSFER
                    ? () => true
                    : textValidator,
        },
        bic: {
            type: 'selectSimple',
            options: bics,
            useSearch: true,
            emptyOption: '-',
            optionKeys: { queryKey: 'title' },
            placeholder: 'Bic',
        },
        vat: {
            type: 'text',
            placeholder: 'vat nr',
            disabled: entity.country_code === 'BE',
            title: entity.country_code === 'BE' ? 'Use the kvk field! 🪃' : 'VAT',
            validator: validateVat,
        },
        vat_state: {
            type: 'select',
            msg: 'VIES status',
            options: VAT_STATES.map((title, value) => ({ value, title })),
            // The generic select renders a falsy value as empty, so pass Unknown (0) explicitly.
            value: entity.vat_state ?? VAT_STATE_UNKNOWN,
            disabled: true,
            title: 'Checked with VIES on save and every night. Valid gives VAT code 3B, otherwise 1E.',
        },
        mandate_id: { type: 'text', readOnly: true, placeholder: 'Mandate id' },
        sepa_status: { type: 'boolean', msg: 'sepa' },
        payment_method: {
            type: 'select',
            placeholder: 'Payment method',
            options: [
                { value: PAYMENT_METHOD_DIRECT_DEBIT, title: 'Direct debit' },
                { value: PAYMENT_METHOD_MANUAL_TRANSFER, title: 'Manual transfer' },
            ],
        },
        use_franchise_billing: {
            type: 'boolean',
            msg: 'Invoice via franchise',
        },
        cif_nif_nie: {
            type: 'text',
            placeholder: 'CIF, NIF or NIE',
            validator: validateCifNifNie,
            defaultErrorMsg: 'Format example: 12345678A, B12345678 or X1234567L',
        },
    }
}

const MANDATE_STATUS_COLORS = {
    active: { color: '#333', bgColor: '#d9d3d3' },
    collections_only: { color: '#fff', bgColor: '#e67e22' },
    revoked: { color: '#fff', bgColor: '#d22f2f' },
    archived: { color: '#fff', bgColor: '#d22f2f' },
}

function getMandateStatusColor(status) {
    return MANDATE_STATUS_COLORS[status] || MANDATE_STATUS_COLORS.active
}

const useImportFromAdvanza = (paymentInfo, setErrorModal) => {
    const dispatch = useAppDispatch()
    const [isImporting, setIsImporting] = useState(false)
    const providerId = paymentInfo.service_provider_id
    const reSendPremiumConfirmationMail = () => {
        setIsImporting('mandate')
        return call(
            'office/providers/re-send-premium-confirmation-mail/' + paymentInfo.service_provider_id,
            { method: 'post' },
        )
            .then(() => {
                dispatch(fetchProvider(providerId, true))
            }, setErrorModal)
            .finally(() => setIsImporting(false))
    }
    const sendMandateVerificationEmail = () => {
        setIsImporting('send_verification_mail')
        return call(
            'office/providers/re-send-mandate-verification-mail/' + paymentInfo.payment_info_id,
            { method: 'post' },
        ).finally(() => {
            setIsImporting(false)
        })
    }
    const createMandate = (isPreApproved) => {
        setIsImporting('mandate_' + (isPreApproved ? '1' : '0'))
        return call(
            `office/providers/create-mandate-mollie/${paymentInfo.payment_info_id}/${
                isPreApproved ? 1 : 0
            }`,
            {
                method: 'post',
            },
        )
            .then(() => {
                dispatch(fetchProvider(providerId, true))
            }, setErrorModal)
            .finally(() => setIsImporting(false))
    }
    const createMandatePreApproved = () => createMandate(true)
    const mollieUnsubscribe = () => {
        setIsImporting('mandateCancel')
        return call('office/providers/revoke-mandate-mollie/' + paymentInfo.payment_info_id, {
            method: 'post',
        })
            .then(() => {
                dispatch(fetchProvider(providerId, true))
            }, setErrorModal)
            .finally(() => setIsImporting(false))
    }

    return {
        isImporting,
        createMandatePreApproved: createMandatePreApproved,
        createMandate: () => createMandate(false),
        mollieUnsubscribe: mollieUnsubscribe,
        sendMandateVerificationEmail,
        reSendPremiumConfirmationMail,
    }
}

const PaymentInfoEntity = ({ entityId }) => {
    const { validate, entity, onChangeEntity, renderInput, onSaveEntity } = useChangeEntity(
        {
            store: 'providers',
            name: 'paymentInfo',
            entityId,
            saveFunc: savePaymentData,
        },
        getFields,
    )
    const [errorModal, setErrorModal] = useState(null)
    const [cancelConfirmModal, setCancelConfirmModal] = useState(null)
    const [syncStatus, setSyncStatus] = useState(null)
    const [archiveModal, setArchiveModal] = useState(false)
    const [archives, setArchives] = useState(null)
    const [archivesLoading, setArchivesLoading] = useState(false)
    const {
        isImporting,
        mollieUnsubscribe,
        createMandatePreApproved,
        createMandate,
        sendMandateVerificationEmail,
        reSendPremiumConfirmationMail,
    } = useImportFromAdvanza(entity, setErrorModal)
    const openArchiveModal = () => {
        setArchiveModal(true)
        setArchivesLoading(true)
        call(`office/providers/get-mandate-archives/${entity.service_provider_id}`)
            .then((response) => setArchives(response.archives))
            .catch((err) => setArchives([]))
            .finally(() => setArchivesLoading(false))
    }
    // Rejects on save failure so callers can stop follow-up actions (e.g. the Payt sync).
    const saveEntity = () =>
        onSaveEntity().then(({ id, vat_state, vat, vat_checked_at, vat_consultation_number }) => {
            onChangeEntity({
                payment_info_id: id,
                vat_state,
                vat,
                vat_checked_at,
                vat_consultation_number,
            })
        })
    const onSave = () => {
        validate() && saveEntity().catch((error) => setErrorModal(error))
    }
    const onSaveAndSync = () => {
        if (!validate()) {
            return
        }
        setSyncStatus(null)
        // Sync must also work without a payment-details edit (e.g. after a
        // provider-profile phone change), so only save when there is something to save.
        const saveIfTouched = entity._isTouched ? saveEntity() : Promise.resolve()
        saveIfTouched.then(
            () =>
                call('office/providers/sync-payment-collector/' + entity.payment_info_id, {
                    method: 'post',
                }).then(
                    () => setSyncStatus('success'),
                    () => setSyncStatus('error'),
                ),
            (error) => setErrorModal(error),
        )
    }

    const isDirectDebit = entity.payment_method === PAYMENT_METHOD_DIRECT_DEBIT
    const isNew = `${entity.payment_info_id}`.indexOf('new') === 0
    const { isFranchiseMain, useFranchiseBilling, provider } = useProvider(
        entity.service_provider_id,
    )
    return (
        <div>
            <Row middle="xs">
                {entity.subscription_status && (
                    <Col x>
                        Status:{' '}
                        <Label
                            text={entity.subscription_status}
                            color={
                                entity.subscription_status === SUBSCRIPTION_STATUS_ACTIVE
                                    ? '#333'
                                    : '#fff'
                            }
                            bgColor={
                                entity.subscription_status === SUBSCRIPTION_STATUS_ACTIVE
                                    ? '#d9d3d3'
                                    : '#d22f2f'
                            }
                        />
                    </Col>
                )}{' '}
                {entity.mandate_status && (
                    <Col x>
                        Mandate:{' '}
                        <Label
                            text={entity.mandate_status.replace(/_/g, ' ')}
                            color={getMandateStatusColor(entity.mandate_status).color}
                            bgColor={getMandateStatusColor(entity.mandate_status).bgColor}
                        />
                        {entity.mandate_status !== 'active' && entity.mandate_churn_date && (
                            <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                                Churned: {entity.mandate_churn_date.split('T')[0]}
                                {entity.mandate_churn_reason &&
                                    ` (${entity.mandate_churn_reason.replace(/_/g, ' ')})`}
                            </div>
                        )}
                    </Col>
                )}{' '}
                {entity.subscription_status === SUBSCRIPTION_STATUS_UNVERIFIED && (
                    <Col x>
                        <SafeButton
                            textButton
                            disabled={isImporting === 'send_verification_mail'}
                            action={sendMandateVerificationEmail}
                            buttonText="sendMandateVerificationEmail"
                        />
                    </Col>
                )}
                {entity.external_mandate_id && (
                    <Col x>
                        <button name="delete" onClick={() => setCancelConfirmModal(true)}>
                            <PreIcon icon="delete_forever">
                                <b>Revoke mandate</b>
                            </PreIcon>
                        </button>
                    </Col>
                )}
                {(!entity.external_mandate_id ||
                    entity.subscription_status === SUBSCRIPTION_STATUS_CANCELLED) && (
                    <Col x>
                        <SafeButton
                            textButton
                            action={createMandatePreApproved}
                            disabled={isImporting}
                            buttonText={
                                isImporting === 'mandate_1' ? (
                                    <LoadingDots />
                                ) : (
                                    <span>
                                        Create pre-approved mandate (Mollie){' '}
                                        <HoverText>
                                            Create pre-confirmed mandate, no confirmation mail will
                                            be sent.
                                        </HoverText>
                                    </span>
                                )
                            }
                        />
                    </Col>
                )}
                {!entity.external_mandate_id && (
                    <Col x>
                        <SafeButton
                            textButton
                            action={createMandate}
                            disabled={isImporting}
                            buttonText={
                                isImporting === 'mandate_0' ? (
                                    <LoadingDots />
                                ) : (
                                    'Create mandate (mollie)'
                                )
                            }
                        />
                    </Col>
                )}
                {entity.external_mandate_id &&
                    entity.subscription_status === SUBSCRIPTION_STATUS_ACTIVE && (
                        <Col x>
                            <SafeButton
                                textButton
                                action={reSendPremiumConfirmationMail}
                                disabled={isImporting}
                                buttonText={
                                    isImporting === 'mandate' ? (
                                        <LoadingDots />
                                    ) : (
                                        '(Re)send premium confirmation mail'
                                    )
                                }
                            />
                        </Col>
                    )}
                <Col x>
                    <button onClick={openArchiveModal}>
                        <PreIcon icon="history">
                            <b>Mandate history</b>
                        </PreIcon>
                    </button>
                </Col>
            </Row>
            <Divider m />
            <Row middle="xs">
                <Col xs>{renderInput('gender')}</Col>
                <Col xs>{renderInput('first_name')}</Col>
                <Col xs>{renderInput('last_name')}</Col>
            </Row>
            <Divider m />
            {renderInput('business_name')}
            <Divider m />
            {renderInput('email')}
            <Divider m />
            <InputField
                disabled
                value={provider?.phone || ''}
                placeholder="Phone (from provider profile)"
            />
            <Divider m />
            <Row middle="xs">
                <Col xs>{renderInput('street')}</Col>
                <Col xs>{renderInput('house_number')}</Col>
                <Col xs>{renderInput('house_number_add')}</Col>
            </Row>
            <Divider m />
            <Row>
                <Col xs>{renderInput('postal_code')}</Col>
                <Col xs>{renderInput('city')}</Col>
                <Col xs>{renderInput('country_code')}</Col>
            </Row>
            <Divider m />
            {renderInput('iban')}
            <Divider m />
            {renderInput('bank_tnv')}
            <Divider m />
            {renderInput('bic')}
            <Divider m />
            {countrySettings[entity.country_code.toUpperCase()].useVatNumber && (
                <div>
                    {renderInput('vat')}
                    {entity.country_code.toUpperCase() === 'BE' && (
                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                            Filled from the KBO number (kvk field of the provider) when empty or
                            when the KBO number changes; otherwise the stored number is kept
                        </div>
                    )}
                    <Divider m />
                    {renderInput('vat_state')}
                    <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                        {entity.vat_checked_at
                            ? `Last VIES answer: ${new Date(entity.vat_checked_at).toLocaleDateString('en-CA', { timeZone: 'Europe/Amsterdam' })}`
                            : 'No VIES answer yet'}
                        {entity.vat_consultation_number &&
                            ` (consultation number ${entity.vat_consultation_number})`}
                    </div>
                    <Divider m />
                </div>
            )}
            {entity.country_code &&
                countrySettings[entity.country_code.toUpperCase()]?.useCifNifNie && (
                    <div>
                        {renderInput('cif_nif_nie')}
                        <Divider m />
                    </div>
                )}
            <Row>
                <Col xs>{renderInput('payment_method')}</Col>
                <Col x> {renderInput('sepa_status')}</Col>
            </Row>
            <Divider m />
            {isDirectDebit && renderInput('mandate_id')}
            <Divider m />
            {(isFranchiseMain || useFranchiseBilling) && (
                <>
                    <div>
                        {isFranchiseMain ? (
                            <span style={{ display: 'inline-block' }}>
                                {renderInput('use_franchise_billing')}
                            </span>
                        ) : useFranchiseBilling ? (
                            <PreIcon green icon="groups">
                                <b style={{ color: 'green' }}>Invoiced via franchise</b>
                            </PreIcon>
                        ) : null}
                    </div>
                    <Divider m />
                </>
            )}
            <Row end="xs">
                {!entity.mandate_id && !isNew && isDirectDebit && (
                    <Col x>
                        <Button onClick={() => createMandate(entity, onChangeEntity)}>
                            Create mandate
                        </Button>
                    </Col>
                )}
                <Col x>
                    <Button disabled={!entity._isTouched || entity._saving} onClick={onSave}>
                        {entity._saving ? '..saving' : 'Save'}
                    </Button>
                </Col>
                {!isNew && entity.external_collector_id && (
                    <Col x>
                        <Button disabled={entity._saving} onClick={onSaveAndSync}>
                            <PreIcon icon="sync">
                                {entity._saving ? '..saving' : 'Save & Send to Payt'}
                            </PreIcon>
                        </Button>
                    </Col>
                )}
                {syncStatus === 'success' && (
                    <Col x>
                        <span style={{ color: 'green' }}>Synced to payment collector</span>
                    </Col>
                )}
                {syncStatus === 'error' && (
                    <Col x>
                        <span style={{ color: 'red' }}>Sync failed</span>
                    </Col>
                )}
            </Row>
            <Modal open={errorModal} close={() => setErrorModal(null)}>
                <pre>{JSON.stringify(errorModal, null, 2)}</pre>
            </Modal>
            <Modal open={cancelConfirmModal} close={() => setCancelConfirmModal(false)}>
                <h3>Cancel & unlink Mollie subscription</h3>
                <p style={{ color: 'red' }}>This action can't be undone</p>
                <Divider m />
                <Button
                    name="delete"
                    onClick={() => mollieUnsubscribe().then(() => setCancelConfirmModal(false))}>
                    <PreIcon red icon={isImporting === 'mandateCancel' ? 'blender' : 'coronavirus'}>
                        {isImporting === 'mandateCancel' ? (
                            <LoadingDots color="red" />
                        ) : (
                            'Cancel subscription '
                        )}
                    </PreIcon>
                </Button>
            </Modal>
            <Modal
                open={archiveModal}
                maxWidth={800}
                close={() => {
                    setArchiveModal(false)
                    setArchives(null)
                }}>
                <h3>Mandate Archive</h3>
                <Divider m />
                {archivesLoading && <LoadingDots />}
                {!archivesLoading && archives && archives.length === 0 && (
                    <p style={{ color: '#888' }}>No archived mandates</p>
                )}
                {!archivesLoading && archives && archives.length > 0 && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr
                                style={{
                                    borderBottom: '2px solid #ddd',
                                    textAlign: 'left',
                                }}>
                                <th style={{ padding: '6px 8px' }}>Mandate ID</th>
                                <th style={{ padding: '6px 8px' }}>IBAN last 4</th>
                                <th style={{ padding: '6px 8px' }}>Churn reason</th>
                                <th style={{ padding: '6px 8px' }}>Created</th>
                                <th style={{ padding: '6px 8px' }}>Revoked</th>
                                <th style={{ padding: '6px 8px' }}>Retention expiry</th>
                            </tr>
                        </thead>
                        <tbody>
                            {archives.map((a, i) => (
                                <tr
                                    key={i}
                                    style={{
                                        borderBottom: '1px solid #eee',
                                    }}>
                                    <td style={{ padding: '6px 8px' }}>{a.external_mandate_id}</td>
                                    <td style={{ padding: '6px 8px' }}>{a.iban_last4 || '-'}</td>
                                    <td style={{ padding: '6px 8px' }}>
                                        {a.churn_reason ? a.churn_reason.replace(/_/g, ' ') : '-'}
                                    </td>
                                    <td style={{ padding: '6px 8px' }}>
                                        {a.mandate_created_date
                                            ? a.mandate_created_date.split(' ')[0]
                                            : '-'}
                                    </td>
                                    <td style={{ padding: '6px 8px' }}>
                                        {a.mandate_revoked_date
                                            ? a.mandate_revoked_date.split(' ')[0]
                                            : '-'}
                                    </td>
                                    <td style={{ padding: '6px 8px' }}>
                                        {a.retention_expiry_date || '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </Modal>
        </div>
    )
}

export default PaymentInfoEntity
